<template>
  <div>
    <div class="modal fade" id="modalChangeStatusNPWPDoc" role="dialog">
      <div class="modal-dialog modal-dialog-centered inter-font">
        <div class="modal-content">
          <div class="modal-header">
            <div class="change-title">
              <h4 class="modal-title">Document NPWP/SKT</h4>
            </div>
            <button type="button" class="close" data-dismiss="modal" @click="resetField">
              &times;
            </button>
          </div>
          <div class="modal-body container w-100">
            <div
              v-if="NPWPStatus == 0 && docStatus != 2"
              class="row align-items-start mt-2"
            >
              <div class="col-4 pr-1 d-flex justify-content-between">
                <label class="mb-0">Company Name (NPWP)</label>
                <p class="mb-0">:</p>
              </div>
              <div class="col-8 pl-1">
                <div class="d-flex align-items-center w-100">
                  <input
                    type="text"
                    name="companyNameNPWP"
                    placeholder="PT ABCD"
                    v-model="companyNameNPWP"
                    @blur="$v.companyNameNPWP.$touch()"
                    class="form-control flex-grow-1"
                    :style="
                      $v.companyNameNPWP.$error
                        ? 'border: 1px solid red; border-radius:5px'
                        : ''
                    "
                  />
                </div>
                <p
                  v-if="$v.companyNameNPWP.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Company Name (NPWP) must be filled
                </p>
              </div>
            </div>
            <div
              v-if="NPWPStatus == 0 && docStatus != 2"
              class="row align-items-start mt-2"
            >
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label class="mb-0">NPWP</label>
                <p class="mb-0">:</p>
              </div>
              <div class="col-8 pl-1">
                <div class="d-flex align-items-center w-100">
                  <input
                    type="text"
                    name="npwp16"
                    placeholder="0123456789012345 "
                    min="16"
                    max="16"
                    v-model="npwpNumber16"
                    @blur="$v.npwpNumber16.$touch()"
                    class="form-control flex-grow-1"
                    @keypress="isNumber($event)"
                    :style="
                      $v.npwpNumber16.$error
                        ? 'border: 1px solid red; border-radius:5px'
                        : ''
                    "
                  />
                </div>
                <p
                  v-if="$v.npwpNumber16.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  NPWP must be filled and has 16 digits number
                </p>
              </div>
            </div>
            <div
              v-if="NPWPStatus == 0 && docStatus != 2"
              class="row align-items-start mt-2"
            >
              <div class="col-4 pr-1 d-flex justify-content-between mt-2">
                <label class="mb-0">NITKU (Jika Ada)</label>
                <p class="mb-0">:</p>
              </div>
              <div class="col-8 pl-1">
                <div class="d-flex align-items-center w-100">
                  <input
                    type="text"
                    name="npwp"
                    placeholder="01213456789012345000000"
                    min="22"
                    max="22"
                    v-model="npwpNumber22"
                    @blur="$v.npwpNumber22.$touch()"
                    class="form-control flex-grow-1"
                    @keypress="isNumber($event)"
                    :style="
                      $v.npwpNumber22.$error
                        ? 'border: 1px solid red; border-radius:5px'
                        : ''
                    "
                  />
                </div>
                <p
                  v-if="$v.npwpNumber22.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  NITKU must have 22 digits number
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2" v-if="NPWPStatus == 0">
              <div class="col-4 pr-1 d-flex justify-content-between mt-0">
                <label class="mb-0">Status</label>
                <p class="my-0">:</p>
              </div>
              <div class="col-8 pl-1">
                <select
                  class="form-control"
                  v-model="docStatus"
                  @blur="$v.docStatus.$touch()"
                  :style="
                    $v.docStatus.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                >
                  <option value="0">None</option>
                  <option value="1">Approve</option>
                  <option value="2">Reject</option>
                </select>
                <p
                  v-if="$v.docStatus.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Status must be selected either Approve or Reject
                </p>
              </div>
            </div>
            <div class="row align-items-start mt-2" v-if="docStatus == 2">
              <div class="col-4 pr-1 d-flex justify-content-between mt-0">
                <label class="mb-0">Reason</label>
                <p class="my-0">:</p>
              </div>
              <div class="col-8 pl-1">
                <textarea
                  rows="3"
                  class="form-control form-control-sm"
                  v-model="rejectReason"
                  @blur="$v.rejectReason.$touch()"
                  :style="
                    $v.rejectReason.$error
                      ? 'border: 1px solid red; border-radius:5px'
                      : ''
                  "
                ></textarea>
                <p
                  v-if="$v.rejectReason.$error"
                  class="text-danger mb-0"
                  style="font-size: 12px"
                >
                  Reason must be filled
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger btn-sm"
              data-dismiss="modal"
              @click="resetField"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-primary btn-sm"
              disabled
              v-if="loadingSubmit"
            >
              <img src="~@/assets/images/2.gif" style="height: 24px" />Save
            </button>
            <button
              v-else
              type="button"
              class="btn btn-primary btn-sm"
              @click="updateStatusNPWPDoc"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  required,
  minLength,
  maxLength,
  between,
  requiredIf,
} from "vuelidate/lib/validators";

export default {
  props: {
    NPWPStatus: {
      type: Number,
      required: true,
    },
    lesseeData: {
      type: Object,
      required: true,
    },
    newCompany: {
      type: Boolean,
      required: true,
    },
    companyId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loadingSubmit: false,
      docStatus: 0,
      companyNameNPWP: "",
      npwpNumber16: "",
      npwpNumber22: "",
      adminId: "",
      rejectReason: "",
    };
  },
  validations: {
    docStatus: {
      required,
      between: between(1, 2),
    },
    rejectReason: {
      required: requiredIf(function () {
        return this.docStatus == 2;
      }),
    },
    companyNameNPWP: {
      required,
    },
    npwpNumber16: {
      required,
      minLength: minLength(16),
      maxLength: maxLength(16),
    },
    npwpNumber22: {
      minLength: minLength(22),
      maxLength: maxLength(22),
    },
  },
  watch: {
    lesseeData(val) {
      if (val.detailLessee && val.detailLessee.length > 0) {
        this.setInitialData(val.detailLessee[0]);
      }
    },
  },
  methods: {
    setInitialData(data) {
      const { companyNPWP16, companyNPWP22, companyNameNPWP } = data;
        this.npwpNumber16 = companyNPWP16;
        this.npwpNumber22 = companyNPWP22;
        this.companyNameNPWP = companyNameNPWP;
    },
    resetField() {
      this.docStatus= 0
      this.rejectReason= ""
      this.setInitialData(this.lesseeData.detailLessee[0])
      this.$v.$reset();
    },
    updateStatusNPWPDoc() {
      this.$v.$touch();
      const isValid = !this.$v.$invalid;
      if (!isValid) {
        swal("Field Error", "Please check all error field", "error");
        return;
      }
      this.loadingSubmit = true;
      const { companyKTPNumber, aktaAddress, userId } =
        this.lesseeData.detailLessee[0];
      this.$http
        .post(
          process.env.UPDATE_COMPANY_DOC_STATUS,
          {
            lesseeId: userId,
            type: "NPWP/SKT",
            userKTP: companyKTPNumber,
            newStatus: this.docStatus,
            adminId: this.adminId,
            rejectReason: this.rejectReason.replace(this.spaceRegex, " "),
            npwpNumber16: this.npwpNumber16.replace(this.spaceRegex, " "),
            npwpNumber22: this.npwpNumber22.replace(this.spaceRegex, " "),
            aktaAddress,
            newCompany: this.newCompany,
            companyNameNPWP: this.companyNameNPWP.replace(this.spaceRegex, " ")
          },
          {
            headers: { "Asani-Token": localStorage.getItem("jwt") },
          }
        )
        .then((response) => {
          this.loadingSubmit = false;
          if (response.data.status == 400) {
            swal("Sorry", response.data.message, "error", {
              button: "Close",
            });
            this.handleLogout();
          }
          if (response.data.status == 200) {
            swal("Success", response.data.message, "success", {
              button: "Close",
            });
            this.resetField()
            $("#modalChangeStatusNPWPDoc").modal("hide");
            this.$emit("success-change-document-npwp-status");
          }
        })
        .catch(function (error) {
          this.loadingSubmit = false;
          swal("Error", error.message, "error");
        });
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("endrent_cache");
      localStorage.removeItem("changeCatalogPermission");
      this.$router.push("/");
    },
  },
  mounted() {
    this.adminId = localStorage.getItem("admin_id");
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap");

.inter-font {
  font-family: "Inter", serif;
  font-optical-sizing: auto;
  font-weight: 400;
  font-style: normal;
}

/* Removing the default arrow */
select {
  -webkit-appearance: none;
  appearance: none;
}

/* Custom arrow */
select {
  background-image: url("~@/assets/icon/arrow-down-solid.svg");
  background-size: 12px;
  background-repeat: no-repeat;
  background-position: calc(100% - 12px) center;
}

p,
label,
input,
textarea,
span,
option,
select {
  color: #2e3646;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/Partnership/Component/ModalChangeNPWPDocStatus.vue